import SignInStore from './SignInStore';
import SignInContainer from './SignInContainer';

const signInStore = new SignInStore();

function SignIn() {
  return <SignInContainer store={signInStore} />;
}
export default SignIn;
